export default "__VITE_ASSET__3OpVwIve__"